const state = {
  overallRangeValue: {},
  overallTotalValue: '',
  textAreasValidObject: {},
  saveFlag: '',
  existingReviews: []
}

const getters = {
  getOverallRangeValueByKey: (state) => (id) => {
    return state.overallRangeValue[id]
  },
  getOverallRangeValueMap: (state) => state.overallRangeValue,
  getOverallTotalValue: (state) => state.overallTotalValue,
  getTextAreasValidObject: (state) => state.textAreasValidObject,
  getSaveFlag: (state) => state.saveFlag,
  getExistingReviews: (state) => state.existingReviews
}

const actions = {}

const mutations = {
  setOverallRangeValue: (state, { key, overallRangeValue }) => {
    state.overallRangeValue = {
      ...state.overallRangeValue,
      [key]: parseInt(overallRangeValue)
    }
  },
  setTextAreaValidEntry: (state, { key, value }) => {
    state.textAreasValidObject = {
      ...state.textAreasValidObject,
      [key]: value
    }
  },

  setSaveFlag: (state, saveFlag) => (state.saveFlag = saveFlag),
  setOverallTotalValue: (state, overallTotalValue) => (state.overallTotalValue = parseInt(overallTotalValue)),
  setExistingReviews: (state, reviews) => (state.existingReviews = reviews)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
